/**
 *  @shelf-version: 1.0.0
 */

import UserPreferences from './user-preferences'

export default UserPreferences
